// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loading_spinner__3l8Ax","spin":"Loading_spin__1vmJg"};